import { Component, OnInit } from '@angular/core';
import { Refreshable } from '../../types/refreshable';

/* global require, window */

@Component({
  selector: 'app-footer',
  template: require('./footer.component.html'),
})
export class FooterComponent implements OnInit, Refreshable {
  api = '';

  ngOnInit() {
    if (window.api_url.includes('staging')) {
      this.api = 'STAGING';
    }
    if (window.api_url.includes('icservice')) {
      this.api = 'DEV';
    }
    if (window.api_url.includes('ictesting')) {
      this.api = 'TESTING';
    }
  }

  refresh() {
    if (window.api_url.includes('staging')) {
      this.api = 'STAGING';
    } else if (window.api_url.includes('icservice')) {
      this.api = 'DEV';
    } else if (window.api_url.includes('ictesting')) {
      this.api = 'TESTING';
    } else {
      this.api = '';
    }
  }
  restoreDefaults!: () => void;
}
